"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeConverter = void 0;
const DesignSystem_1 = require("./..");
const THEME = __importStar(require("../../themes/colors"));
const themeConverter = (theme) => {
    switch (theme) {
        case THEME.cobalt:
            return DesignSystem_1.cobaltTheme;
        case THEME.denim:
            return DesignSystem_1.denimTheme;
        case THEME.green:
            return DesignSystem_1.greenTheme;
        case THEME.malachite:
            return DesignSystem_1.malachiteTheme;
        case THEME.red:
            return DesignSystem_1.redTheme;
        case THEME.salesforce:
            return DesignSystem_1.salesforceTheme;
        case THEME.silver:
            return DesignSystem_1.silverTheme;
        case THEME.teal:
            return DesignSystem_1.tealTheme;
        case THEME.yellow:
            return DesignSystem_1.yellowTheme;
        case THEME.virilisGreen:
            return DesignSystem_1.virilisGreenTheme;
        default:
            return DesignSystem_1.baseTheme;
    }
};
exports.themeConverter = themeConverter;
//# sourceMappingURL=themeConverter.js.map